import { styled } from "baseui";

type ChipProps = {
  $selected?: boolean;
  $size?: "small" | "medium" | "large";
  shadow?: boolean;
};
export const Chip = styled<"button", ChipProps>(
  "button",
  ({ $selected = false, $size = "medium", shadow = false }) => {
    const sizeStyles = {
      small: {
        padding: "0.25rem 0.5rem",
        fontSize: "0.75rem",
      },
      medium: {
        padding: "0.5rem 1rem",
        fontSize: "1rem",
      },
      large: {
        padding: "0.75rem 1.3rem",
        fontSize: "1.25rem",
        borderRadius: "30px",
      },
    };

    return {
      backgroundColor: $selected ? "var(--tenant-primary, #111827)" : "#eee",
      color: $selected ? "white" : "black",
      border: "none",
      marginRight: "0.5rem",
      borderRadius: "20px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
      boxShadow: shadow && $selected ? "0 4px 8px rgba(0, 0, 0, 0.2)" : "none",
      ...sizeStyles[$size],
    };
  }
);
